import { LicenseInfo } from "@mui/x-license";

LicenseInfo.setLicenseKey(
    // eslint-disable-next-line max-len
    "f512ed564171519c5ef2447b1de417b2Tz0xMjQ3MDYsRT0xODAwNzQ4Nzk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=",
);
